<template>
  <b-button variant="default" type="button" class="float-left" v-bind:class="{ 'ml-3': isMarginLeft }" @click.prevent="onClick"><font-awesome-icon icon="chevron-left"/>  Back</b-button>
</template>
<script>
  export default {
    props: {
      isMarginLeft: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    methods: {
      onClick () {
        window.goBack(this)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Buttons/Back.vue